import script from "./ContactInformation.vue?vue&type=script&setup=true&lang=js"
export * from "./ContactInformation.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__